import React, { PureComponent } from 'react';
import axios from 'axios';
import Cookie from 'js-cookie';
import $ from "jquery";
import IsEmpty from "../../components/helpers/IsEmpty";
import Config from "../../components/axios/Config";
import RoutePath from '../../components/RoutePath';
import Modal from "../../components/helpers/Modal";
import SwalToast from "../../components/helpers/SwalToast";
import { Redirect } from 'react-router-dom';

class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            forgot_password_email: '',
            button_disabled: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSendResetPassword = this.handleSendResetPassword.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            errors: []
        }, () => {
            let data = new FormData(event.target);

            const user = {
                email: data.get('email'),
                password: data.get('password')
            };

            axios.post(`${process.env.REACT_APP_BASE_API_URL}login`, user, Config()).then(res => {
                console.log(res.data);
                if (res.data.data.access_token) {
                    Cookie.set('token', res.data.data.access_token);
                    Cookie.set('refresh_token', res.data.data.refresh_token);
                    Cookie.set('user', res.data.data.user);
                    // initializeAuthorization();
                    // requestFCMToken();
                    if (this.props.location?.state?.id) {
                        this.props.history.push({
                            pathname: `${RoutePath.GOAT_CARD.replace(":id", this.props.location?.state?.id)}`
                        });
                    } else {
                        this.props.history.push({
                            pathname: RoutePath.DASHBOARD
                        });
                    }
                } else {
                    SwalToast.fire({
                        icon: 'error',
                        title: 'Wrong Credential!'
                    });
                }
            }).catch((error) => {
                if (error.response !== undefined) {
                    if (error.response.status === 429) {
                        this.setState({
                            errors: {
                                wrong: ["Too many attempts. Please try again in one minute."]
                            }
                        });
                    } else {
                        this.setState({
                            errors: {
                                wrong: [error.response.data.message]
                            }
                        });
                    }
                } else {
                    SwalToast.fire({
                        icon: 'error',
                        title: 'Sorry, we have a problem right now, please try again later.'
                    });
                }
            }).finally();
        });
    }

    handleSendResetPassword(event) {
        event.preventDefault();
        this.setState({
            button_disabled: true
        }, () => {
            $('#forgot-password-modal').modal('hide');
            axios.post(`${process.env.REACT_APP_BASE_API_URL}send-reset-password`, {
                email: this.state.forgot_password_email
            }, Config()).then(response => {
                SwalToast.fire({
                    icon: 'success',
                    title: 'Successfully sent!'
                });
            }).catch((error) => {
                SwalToast.fire({
                    icon: 'error',
                    title: error.response ? error.response.data.message : 'Whoops, something went wrong!'
                });
            }).finally(() => {
                this.setState({
                    button_disabled: false
                });
            });
        });
    }

    render() {
        if (Cookie.get('token')) return <Redirect to={RoutePath.DASHBOARD} />
        else return (
            <div className="container">
                <Modal modalId={"forgot-password-modal"} title={"Reset Your Password"}>
                    <form className="mt-2 mb-0 p-0" onSubmit={this.handleSendResetPassword}>
                        <label htmlFor="forgot-password-email" className="color-374650">Email</label>
                        <input
                            required
                            id="forgot-password-email"
                            type="email"
                            className="form-control"
                            value={this.state.forgot_password_email}
                            onChange={event => this.setState({
                                forgot_password_email: event.target.value
                            })}
                        />
                        <button
                            type="submit"
                            disabled={this.state.button_disabled}
                            className="btn bgc-374650 shadow-graph text-white font-weight-bold mt-3"
                        >Submit</button>
                    </form>
                </Modal>
                <div className="login-content">
                    <div className="text-center">
                        <img src={`${process.env.REACT_APP_PUBLIC_URL}/images/tecta-global-logo.png`} alt="" className="w-50" />
                    </div>
                    <div className="card shadow-graph mt-4">
                        <form className="p-4" onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" className="form-control" name="email" required />
                            </div>
                            {this.state.errors.email && <div className="alert alert-danger p-2 mt-2 text-center" role="alert">{this.state.errors.email[0]}</div>}
                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input type="password" className="form-control" name="password" required />
                            </div>
                            {this.state.errors.wrong && <div className="alert alert-danger p-2 mt-2 text-center" role="alert">{this.state.errors.wrong[0]}</div>}
                            <div className="row">
                                <div className="col-6 d-flex align-items-center">
                                    <a href="javascript:void(0)" className="text-decoration-none" data-toggle="modal" data-target="#forgot-password-modal">Forgot Password?</a>
                                </div>
                                <div className="col-6 d-flex align-items-center justify-content-end">
                                    <button className="btn bgc-0F74BD font-weight-bold text-white">Login</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;